import React, { useContext, useEffect, useMemo, useState } from 'react'
import review_img1 from '../../assets/img/review_img1.png'
import review_user from '../../assets/img/review_user_img.png'
import chat_img from '../../assets/img/svg/chat-icon.svg'
import Empty_star from '../../assets/img/star-icon.png'
import { useDispatch, useSelector } from 'react-redux'
import { getAllNeedReviews, getAllReviewed } from '../../redux/slices/reviewSlice'
import { appendImageURL, convertTimestampToDate } from '../../helper/function'
import { useNavigate } from 'react-router-dom'
import { Rating } from 'react-simple-star-rating'
import { createChatRoom } from '../../redux/slices/chatSlice'
import { errorToast } from '../../util/Toast/toast'
import { FREEZE_CLIENT_MSG, NoFoundText } from '../../util/constant'
import Pagination from '../../component/common/pagination'
import { SpinnerContext } from '../../context/spinnerContext'
import NoDataFound from '../../component/noDataFound'

const Reviews = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { allNeedReviews, allReviewed } = useSelector(({ reviews }) => reviews)
  const { user } = useSelector(({ auth }) => auth)
  const { changeLoader } = useContext(SpinnerContext)

  const [currentPage, setCurrentPage] = useState(1)
  const [currentReviewdPage, setCurrentReviewdPage] = useState(1)
  const [activeTab, setActiveTab] = useState('needReview') // Track the active tab
  const [loading, setLoading] = useState(true)

  const itemsPerPage = useMemo(() => 6, [])
  const itemsPerReviewdPage = useMemo(() => 6, [])

  const handlePageChange = (selectedItem) => setCurrentPage(selectedItem.selected + 1)
  const handleReviewdPageChange = (selectedItem) => setCurrentReviewdPage(selectedItem.selected + 1)

  const fetchReviews = async () => {
    changeLoader(true) // Start loading
    setLoading(true)
    const fetchAction = activeTab === 'needReview' ? getAllNeedReviews : getAllReviewed
    await dispatch(
      fetchAction({
        page: activeTab === 'needReview' ? currentPage : currentReviewdPage,
        limit: activeTab === 'needReview' ? itemsPerPage : itemsPerReviewdPage
      })
    )
    setTimeout(() => {
      setLoading(false)
    }, 1005)
    changeLoader(false) // End loading
  }

  useEffect(() => {
    fetchReviews()
  }, [activeTab, currentPage, currentReviewdPage])

  const handleTabChange = (tab) => {
    setActiveTab(tab)
    setCurrentPage(1) // Reset pagination when tab changes
    setCurrentReviewdPage(1)
  }

  const onViewChat = (id) => {
    if (user?.is_freezed_client) {
      errorToast(FREEZE_CLIENT_MSG)
      return
    }
    dispatch(createChatRoom(id))
      .then(({ payload }) => {
        if (payload?.status === 200) {
          if (payload?.data?.data) {
            const chat_room_id = payload?.data?.data?.chat_room_id
            navigate(`/chat/${chat_room_id}`, { state: id })
          } else {
            errorToast(payload?.data?.status_message || 'Something went wrong')
          }
        }
      })
      .catch((err) => {
        console.log('err :>> ', err)
      })
  }

  const viewDetails = (id) => {
    navigate(`/cleaning-details/${id}`)
  }
  return (
    <div className="page-wrapper">
      <div className="reviews_section">
        <div className="reviews_topbar">
          <ul className="nav nav-pills" id="pills-tab" role="tablist">
            <li className="nav-item review_btn" role="presentation">
              <button
                className={`nav-link ${activeTab === 'needReview' ? 'active' : ''}`}
                onClick={() => handleTabChange('needReview')}
                type="button"
              >
                Need Review
              </button>
            </li>
            <li className="nav-item review_btn" role="presentation">
              <button className={`nav-link ${activeTab === 'reviewed' ? 'active' : ''}`} onClick={() => handleTabChange('reviewed')} type="button">
                Reviewed
              </button>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content" id="pills-tabContent">
        {/* Need Review Tab */}
        {activeTab === 'needReview' && (
          <div className="tab-pane fade show active" role="tabpanel">
            <div className="need_review_section row">
              {!loading && allNeedReviews?.scheduledProperties?.length > 0
                ? allNeedReviews?.scheduledProperties?.map((_review, index) => (
                    <div className="col-md-12 col-ld-6 col-xl-6" key={index}>
                      <div className="need_review_sec_card">
                        <div className="review_img_main_div">
                          <img
                            className="review_img"
                            src={
                              _review?.properties_id?.property_image?.length > 0
                                ? appendImageURL(_review?.properties_id?.property_image?.[0])
                                : review_img1
                            }
                            alt="review_img"
                          />
                        </div>

                        <div className="need_sec_card_data_one">
                          <div className="need_sec_card_subdata">
                            <h3 className="review_card_title">{_review?.properties_id?.property_name}</h3>
                            <h5 className="review_card_subtitle">{_review?.properties_id?.address}</h5>
                            <div className="review_user_sec">
                              <img
                                className="review_user"
                                src={
                                  _review?.cleanings?.scheduleCleaners?.cleaners?.profile_image
                                    ? appendImageURL(_review?.cleanings?.scheduleCleaners?.cleaners?.profile_image)
                                    : review_user
                                }
                                alt="review_user"
                              />
                              <div>
                                <h4 className="review_user_name">
                                  {_review?.cleanings?.scheduleCleaners?.cleaners?.first_name}{' '}
                                  {_review?.cleanings?.scheduleCleaners?.cleaners?.last_name}
                                </h4>
                                <h6 className="review_user_addr">{_review?.cleanings?.scheduleCleaners?.cleaners?.address}</h6>
                              </div>
                            </div>
                          </div>
                          <div className="d-flex justify-content-end flex-column">
                            <p className="review_date">{convertTimestampToDate(_review?.booking_date_time)}</p>
                            <button className="view_chat_btn" onClick={() => onViewChat(_review?.property_schedule_id)}>
                              <p className="view_chat_text"> View Chat </p>
                              <img className="chat_img" src={chat_img} alt="chat_img" />
                            </button>
                            <button className="need_review_review_btn" onClick={() => viewDetails(_review?.property_schedule_id)}>
                              <p className="view_chat_text"> Review </p>
                              <img className="Empty_star" src={Empty_star} alt="Empty_star" />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                : !loading && <NoDataFound title={NoFoundText.REVIEW_PENNDING} />}
            </div>

            {!loading && allNeedReviews?.totalRecords > 6 && (
              <Pagination
                currentPage={currentPage}
                onPageChange={handlePageChange}
                totalPages={allNeedReviews?.totalPage || 0}
                itemsPerPage={itemsPerPage}
              />
            )}
          </div>
        )}

        {/* Reviewed Tab */}
        {activeTab === 'reviewed' && (
          <div className="tab-pane fade show active" role="tabpanel">
            {!loading && allReviewed?.scheduledProperties?.length > 0
              ? allReviewed?.scheduledProperties?.map((_review, index) => (
                  <div className="review_iteam" key={index} onClick={() => viewDetails(_review?.property_schedule_id)}>
                    <div className="review_card">
                      <div className="review_card_img">
                        <img
                          className="review_img"
                          src={
                            _review?.properties_id?.property_image?.length > 0
                              ? appendImageURL(_review?.properties_id?.property_image?.[0])
                              : review_img1
                          }
                          alt="review_img"
                        />
                      </div>
                      <div className="card_section_one">
                        <h3 className="review_card_title">{_review?.properties_id?.property_name}</h3>
                        <h5 className="review_card_subtitle">{_review?.properties_id?.address}</h5>
                        <div className="review_user_sec">
                          <img
                            className="need_review_user"
                            src={
                              _review?.cleanings?.scheduleCleaners?.cleaners?.profile_image
                                ? appendImageURL(_review?.cleanings?.scheduleCleaners?.cleaners?.profile_image)
                                : review_user
                            }
                          />
                          <div>
                            <h4 className="review_user_name">
                              {_review?.cleanings?.scheduleCleaners?.cleaners?.first_name} {_review?.cleanings?.scheduleCleaners?.cleaners?.last_name}
                            </h4>
                            <h6 className="review_user_addr">{_review?.cleanings?.scheduleCleaners?.cleaners?.address}</h6>
                          </div>
                        </div>
                      </div>
                      <div className="card_section_two">
                        <div className="review_rating">
                          <Rating
                            className="star_img"
                            initialValue={_review?.cleaningsReviews?.star} // Set initial value
                            size={25}
                            fillColor="#1C3A77"
                            emptyColor="gray"
                            allowFraction
                            readonly
                          />
                          <p className="review_date">{convertTimestampToDate(_review?.cleaningsReviews?.created_at)}</p>
                        </div>
                        <div>
                          <p className="review_text">{_review?.cleaningsReviews?.description}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              : !loading && <NoDataFound title={NoFoundText.REVIEW_COMPLETE} />}

            {!loading && allNeedReviews?.scheduledProperties?.length > 0 && allReviewed?.totalRecords > 6 && (
              <Pagination
                currentPage={currentReviewdPage}
                onPageChange={handleReviewdPageChange}
                totalPages={allReviewed?.totalPage || 0}
                itemsPerPage={itemsPerReviewdPage}
              />
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default Reviews
